import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwTabService } from 'src/app/librarys/serves/public/sw-tab.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
declare let $, G6;
@Component({
  selector: 'app-graph-view1',
  templateUrl: './graph-view.component.html',
  styleUrls: ['./graph-view.component.css']
})
export class GraphViewComponent1 implements OnInit {
  taskData:any = [];
  // 资源内容页数据
  contentList:any = [];
  dataObj:any = {};
  concepts = [];
  graph: any = null;                 // 图谱对象
  datas: any = {};                   
  allDatas:any = {};
  colorArr:any = [];
  constructor(
    private instanceModuleService: InstanceModuleService,
    private tabService:SwTabService,
    private http: SwHttpClientService,
    private router: Router,
    private kmsService: KmsService,
    private message: SwMassageBoxService,
    private activatedRouter: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activatedRouter.queryParams.subscribe((param) => {
      this.taskData = JSON.parse(param.selectData);
      this.http.Get('assets/kgs/conceptColorConfig.json').subscribe((colorConfig) => {
        this.kmsService.getKeTaskById(this.taskData.taskId).subscribe(
          res => {
            if (res["code"] == '200') {
              // 获取任务信息
              this.taskData = res.data;
              const obj = JSON.parse(res.data.jsonStr);
              if(!obj.fulltext){
                return;
              }
              // 获取分页内容信息
              this.contentList = obj.contentList;
              // 获取全文内容
              const fulltext = obj.fulltext;
              this.taskData.fulltext = fulltext;
              // 根据分页内容信息中的起始结束位置，获取每一页文本
              this.taskData.documentTextArr = [];
              let documentTextArr = [];
              this.contentList.forEach(e => {
                documentTextArr.push(fulltext.slice(e.start,e.end));
              })
              this.taskData.documentTextArr = documentTextArr;
              // 将标注数据转换成当前所需格式
              // 1.若obj.result为空，说明还未进行人工校对，需要从分页内容信息中获取单页抽取结果进行合并展示
              if(!obj.result){
                this.dataObj = this.mergePageExtractResult();
              }
              // 2.若obj.result不为空，说明已进行人工校对，需要从obj.result中获取已合并的全文抽取结果并展示
              else{
                this.dataObj = obj.result;
              }
              this.dataObj.entitys.forEach(e => {
                if(e.tagType === 0){
                  e.color = colorConfig[e.conceptName] ? colorConfig[e.conceptName].color : "rgba(100, 100, 100)";
                  e.bgColor = colorConfig[e.conceptName] ? colorConfig[e.conceptName].bgColor : "rgba(100, 100, 100, 0.3)";
                }
              })
              this.init();
            }
          });
      });
    });
  }

  // 遍历内容信息中的每一页获取抽取结果，并合并展示
  mergePageExtractResult(){
    let allEntities = [], allRelations = [];
    this.contentList.forEach((e,i) => {
      // 判断当前页是否抽取完成，且有抽取结果
      if(e.status == 2 && e.result && e.result.entities.length>0){
        let entities = e.result.entities, relations = e.result.relations, attributes = e.result.attributes, pageText = this.taskData.documentTextArr[i];
        let newEntities = [], newRelations = [];
        const offset = i > 0 ? this.contentList[i-1].end : 0;
        // 将抽取出的实体、属性、关系数据，转换成当前所需格式
        // 1.处理实体信息
        entities.forEach(e => {
          let isOutRange = false;
          const start = pageText.indexOf(e.text);
          if(start < 0){
            isOutRange = true;
          }
          if(!e.type || !e.conceptId){
            isOutRange = true;
          }
          newEntities.push({
            "tagType": 0,  
            "name": e.text,
            "start": start+1+offset,     // 起始和结束位置需加上相对于全文的偏移量
            "end": start+1+e.text.length+offset,   
            "conceptId": e.conceptId,  
            "conceptName": e.type,  
            "conceptCode": e.conceptCode,
            "mapping": e.mapping,
            "uuid": this.instanceModuleService.uuid2(),
            "isOutRange": isOutRange
          });
        });

        // 2.处理实体-关系信息
        if(relations && relations.length > 0){
          relations.forEach(e => {
            if(newEntities[e.subject] && newEntities[e.object]){
              newRelations.push({
                "tagType": 0,  
                "startNodeName": newEntities[e.subject].name,
                "endNodeName": newEntities[e.object].name,
                "startNodeId": newEntities[e.subject].uuid,
                "endNodeId": newEntities[e.object].uuid,
                "uuid": this.instanceModuleService.uuid2(),
                "relationshipId": e.relationshipId,
                "relationName": e.relation,
                "relationAlias": e.relationAlias,
                "relationshipName": e.relationshipName,
                "reverseRelationAlias": e.reverseRelationAlias,
                "reverseRelationName": e.reverseRelationName,
                "sourceList": [
                  {
                    materialId: e.materialId,
                    pageNum: e.pageNum,
                    sourceMaterial: e.sourceMaterial,
                  }
                ],
                "isOutRange": newEntities[e.subject].isOutRange || newEntities[e.object].isOutRange
              })
            }
          })
        }

        // 3.处理实体-属性信息
        if(attributes && attributes.length > 0){
          attributes.forEach(e => {
            if(newEntities[e.entity]){
              const start = pageText.indexOf(e.value);
              const uuid = this.instanceModuleService.uuid2();
              newEntities.push({
                "tagType": 1,  
                "name": e.value,
                "start": start+1+offset,     // 起始和结束位置需加上相对于全文的偏移量
                "end": start+1+e.value.length+offset,   
                "conceptId": newEntities[e.entity].conceptId,  
                "conceptName": newEntities[e.entity].conceptName,  
                "attributeId": e.relationshipId,
                "attributeName": e.relationshipName,
                "englishCode": e.englishCode,
                "sortNum": e.sortNum,
                "sourceList": [
                  {
                    materialId: e.materialId,
                    pageNum: e.pageNum,
                    sourceMaterial: e.sourceMaterial,
                  }
                ],
                "color": '#666666',
                "bgColor": '#dddddd',
                "uuid": uuid,
                "isOutRange": newEntities[e.entity].isOutRange  || start < 0
              });
              newRelations.push({
                "tagType": 1,  
                "startNodeName": newEntities[e.entity].name,
                "endNodeName": e.value,
                "startNodeId": newEntities[e.entity].uuid,
                "endNodeId": uuid,
                "uuid": this.instanceModuleService.uuid2(),
                "relationshipId": e.relationshipId,
                "relationName": e.relationshipName,
                "isOutRange": newEntities[e.entity].isOutRange  || start < 0
              })
            }
          })
        }
        // 过滤掉超出文本范围的实体、关系
        newEntities = newEntities.filter(e => !e.isOutRange);
        newRelations = newRelations.filter(e => !e.isOutRange);
        newEntities.forEach(e => {
          delete e.isOutRange;
        });
        newRelations.forEach(e => {
          delete e.isOutRange;
        });
        
        // 将同一位置多次出现的实体合并
        const mergeData = this.mergeSameEntity(newEntities,newRelations);
        newEntities = mergeData.entitys;
        newRelations = mergeData.relations;

        // 合并到总数据中
        allEntities = allEntities.concat(newEntities);
        allRelations = allRelations.concat(newRelations);
      }
    })
    return {
      entitys: allEntities,
      relations: allRelations
    }
  }

  // 将实体数组中name和start相同的合并成一条数据，关系数组中用到该实体的同步进行修改
  mergeSameEntity(entitys,relations){
    // 合并实体数组
    const mergedEntities = [];
    const uuidMap = {};

    entitys.forEach((entity) => {
      const key = `${entity.name}-${entity.start}-${entity.conceptId}-${entity.tagType}`;
      if (!uuidMap[key]) {
        mergedEntities.push(entity);
        uuidMap[key] = entity.uuid;
      } else {
        // 如果已经存在，更新 uuidMap
        uuidMap[entity.uuid] = uuidMap[key];
      }
    });

    // 更新关系数组
    const updatedRelations = relations.map((relation) => {
      const updatedStartNodeId = uuidMap[relation.startNodeId] || relation.startNodeId;
      const updatedEndNodeId = uuidMap[relation.endNodeId] || relation.endNodeId;
      return {
        ...relation,
        startNodeId: updatedStartNodeId,
        endNodeId: updatedEndNodeId,
      };
    });
    return {
      entitys: mergedEntities,
      relations: updatedRelations,
    };
  }

  // 获取字符串中某个字符出现的所有位置
  getCharIndex(str, char) {
    const indexArr = [];
    let index = str.indexOf(char);  // 第一次出现的位置
    while (index !== -1) {
      indexArr.push(index);
      index = str.indexOf(char, index + 1); // 从下一个位置开始继续查找
    } 
    return indexArr;
  }

  // 初始化
  init() {
    const data = this.dataObj;
    // 处理数据
    this.datas = {
      // 点集
      nodes: [],
      // 边集
      edges: []
    };
    this.concepts = [];
    data.entitys.forEach(e => {
      // 判断当前实体是否已标注
      let isExisted = false;
      for (let i = 0; i < this.datas.nodes.length; i++) {
        let c = this.datas.nodes[i];
        // 已标注（将相同名称、相同类的实体作为同一实体进行展示
        if (e.name == c.label && e.conceptId == c.conceptId && e.tagType == c.tagType) {
          isExisted = true;
          c.ids.push(e.uuid);
          break;
        }
      }
      // 未标注
      if (!isExisted) {
        const c = e.tagType == 0 ? {
          conceptId: e.conceptId,
          conceptName: e.conceptName,
          color: e.bgColor
        }:{
          conceptId: 'attribute',
          conceptName: '属性',
          color: e.bgColor
        }
        this.datas.nodes.push({
          id: e.uuid,
          label: e.name,
          conceptId: c.conceptId,
          conceptName: c.conceptName,
          tagType: e.tagType,
          color: c.color,
          ids: [e.uuid]
        });
        if (this.concepts.filter(n => n.conceptId == c.conceptId).length == 0) {
          this.concepts.push({
            conceptId: c.conceptId,
            conceptName: c.conceptName,
            color: c.color,
            selected: true
          })
        }
      }
    });
    // 获取关系数据
    data.relations.forEach(e => {
      let source = e.startNodeId;
      let item = this.datas.nodes.find(c => c.ids.indexOf(source) > -1);
      source = item.id;
      let target = e.endNodeId;
      item = this.datas.nodes.find(c => c.ids.indexOf(target) > -1);
      target = item.id;
      this.datas.edges.push({
        source: source,
        target: target,
        label: e.relationName,
        id: e.uuid
      })
    });
    this.allDatas = JSON.parse(JSON.stringify(this.datas));
    // 绘制图谱
    setTimeout(() => {
      this.drawGraph();
    }, 0)
  }

  // 根据概念筛选
  selectOrCancelConcept(i){
    if(this.concepts.filter(e => e.selected).length == 1 && this.concepts[i].selected){
      this.message.info('请至少选中一种分类！');
      return;
    }
    this.concepts[i].selected = !this.concepts[i].selected;
    this.datas = {nodes:[],edges:[]};
    // 筛选实例
    this.allDatas.nodes.forEach(e => {
      const item = this.concepts.find(c => c.conceptId == e.conceptId && c.selected);
      if(item){
        this.datas.nodes.push(e);
      }
    });
    // 筛选关系
    this.allDatas.edges.forEach(e => {
      let sN = this.allDatas.nodes.find(n => n.id == e.source);
      let eN = this.allDatas.nodes.find(n => n.id == e.target);
      const sitem = this.concepts.find(c => c.conceptId == sN.conceptId && c.selected);
      const eitem = this.concepts.find(c => c.conceptId == eN.conceptId && c.selected);
      if(sitem && eitem){
        this.datas.edges.push(e);
      }
    });
    // 绘制图谱
    setTimeout(() => {
      this.drawGraph();
    }, 0)
  }

  // 绘制值属性图谱
  drawGraph() {
    const containerId = 'entityRelationGraph';
    let container = $('#' + containerId);
    $('#' + containerId).empty();
    const that = this;
    this.datas.nodes.forEach(el => {
      el.textColor = "#676767";
      const len = el.label.length >= 8 ? 8 : el.label.length;
      const w = len*20 + 20;
      el.size = [w,40];
    });
    const width = container.width();
    const height = container.height();
    const layoutCfg = {
      type: 'force',
      maxIteration: 200,
      preventOverlap: true,
      collisionDetect: true, // 启用内置碰撞检测功能
      nodeSize: 180,
      linkDistance: 280,
      // 自定义节点之间的间距
      nodeSpacing: (d) => {
        return 10
      }
    };

    const modes = ['drag-node', 'drag-canvas', 'zoom-canvas'];
    let graph = new G6.Graph({
      container: containerId,
      width,
      height,
      // fitView: true,
      // fitCenter: true,
      linkCenter: true,   // 是否连接到节点中间
      layout: layoutCfg,
      animate: true,
      // 允许拖拽节点、新增节点、拖拽画布、缩放画布
      modes: {
        default: modes,
      },
      // 节点样式通用性设置
      defaultNode: {
        type: 'rect',
        // 节点样式配置
        style: {
          cursor: 'pointer',
          stroke: '#676767', // 边框颜色
          lineWidth: 2, // 边框宽度
          radius: 5, // 矩形四个角的圆角半径
        },
        // 节点标签文本样式配置
        labelCfg: {
          style: {
            cursor: 'pointer',
            fontSize: 18,
            fontFamily: '微软雅黑'
          }
        }
      },
      // 边样式通用性设置
      defaultEdge: {
        // 边样式配置
        style: {
          stroke: '#dddddd',
          lineWidth: 1,
          endArrow: {
            d: 0,
            stroke: '#bbbbbb',
            fill: '#bbbbbb',
            lineWidth: 1,
            path: G6.Arrow.triangle(12, 8, 35),
          },
        },
        // 边上的标签文本配置
        labelCfg: {
          autoRotate: true, // 边上的标签文本根据边的方向旋转
          style: {
            cursor: 'pointer',
            fill: '#ffffff',
            fontSize: 16,
            fontFamily: '微软雅黑',
            background: {
              fill: '#aaaaaa',
              radius: 15,
              padding: [6, 15, 6, 15]
            }
          }
        },
      }
    });
    // 设置画布初始缩放比例，保证在框内显示
    setTimeout(() => {
      graph.zoom(
        0.75,    // 伸缩比例
        { x: width / 2, y: height / 2 },  //以center的x, y坐标为中心缩放
        true,            //是否带有动画地移动
        { duration: 500 }  // 动画执行时间
      );
    }, 0)
    // 设置最多显示文字长度
    graph.node((node) => {
      // 获取节点的颜色属性
      return {
        style: {
          fill: node.color,
          lineWidth: 0
        },
        labelCfg: {
          style: {
            fill: node.textColor,
            fontSize: 18
          },
          position: 'center',
          maxLength: 8,
          // offset: 15 // 文字距离节点的偏移量
        },
      };
    });
    graph.data({
      nodes: this.datas.nodes,
      edges: this.datas.edges
    });
    graph.render();

    if (typeof window !== 'undefined') {
      window.onresize = () => {
        if (!graph || graph.get('destroyed')) return;
        if (!container || !container.width() || !container.height()) return;
        graph.changeSize(container.width(), container.height());
      };
    }
  }

  // 下载图片
  downloadImage() {
    const canvas = document.getElementById('entityRelationGraph').getElementsByTagName('canvas')[0];
    const dataURL = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.download = this.taskData.taskNum + '-关系图谱.png';
    link.href = dataURL;
    link.click();
  }

  // 返回
  back(){
    this.tabService.closeUrl('/kms/GraphView',true);
  }
}
